<template>
    <div>
        <div class="form-group">
            <label for="cp">Code postal</label>
            <input type="text" class="form-control" id="cp"
                   :placeholder="placeholder_cp"
                   autocomplete="off"
                   v-model="cp"
                   @keyup="keyUpInput"
            >
            <!--<span class="help-block">Help block with error</span>-->
        </div>

        <div class="form-group">
            <label for="ville">Ville</label>
            <input type="text" class="form-control" id="ville"
                   :placeholder="placeholder_ville"
                   v-model="ville"
                   v-show="!show_select_ville(ville)"
            >
            <select class="form-control"
                    v-show="show_select_ville(ville)"
                    @change="ville=$event.target.value"
                    @selected="ville=$event.target.value"
            >
                <option value="">Choisissez une ville</option>
                <option
                        v-for="vil in ville"
                        :value="vil.name"
                >{{vil.name}}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    var $ = require('jquery');
    var _ = require('underscore')

    export default {
        props: {
            reset: Boolean,
            cpProp: String,
            villeProp: [String, Array],
            placeholder_cp: {
                type: String,
                default: function () {
                    return "Code postal"
                }
            },
            placeholder_ville: {
                type: String,
                default: function () {
                    return "Ville"
                }
            },
        },
        data: function () {
            return {
                ville: "",
                cp: ""
            }
        },
        methods: {
            show_select_ville: function (villes) {
                return _.isArray(villes) && villes.length > 1
            },
            keyUpInput:function(event) {
                if (event.key=='Tab')
                    return;
                if (this.cp.length >= 4)
                    this.ville = this.villeByCp(this.cp)
                else
                    this.ville = ''
            },
            villeByCp: function (cp) {
                var result = _.filter(this.getVilles, function (item) {
                    return item.cp == cp;
                });
                if (result.length == 0)
                    return ""
                if (result.length == 1)
                    return result[0].name

                return result
            }
        },
        created: function () {
            this.ville = this.villeProp;
            this.cp = this.cpProp;
        },
        watch: {
            reset: function () {
                this.ville = "";
                this.cp = "";
            },
            ville: function () {
                this.$emit('villeChanged', this.ville)
            },
            cp: function (value) {
                this.$emit('cpChanged', this.cp)
            },
        },
        mounted: function () {
        },
        computed: {
            ...mapGetters({
                getVilles: 'getVilles',
            }),
        },

    };
</script>


// WEBPACK FOOTER //
// src/components/Communs/cpAndVille.vue